import { InjectionToken } from '@angular/core';

export interface BrowserWalletGlobal {
  localStorage?: Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>;
  location?: Pick<Location, 'origin'>;
}

/** Provides injectable access to wallet-related browser globals for app code and tests. */
export const BROWSER_WALLET_GLOBAL = new InjectionToken<BrowserWalletGlobal>('Browser wallet global object', {
  providedIn: 'root',
  factory: () => globalThis as BrowserWalletGlobal,
});
